import jsPDF from 'jspdf';

const jsPDF_ = jsPDF;

export default {
	data() {
		return {
			jsPDF: jsPDF_
		}
	}
}